var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AnimationState } from 'components/transition/private/Animator';
import { Animator } from 'components/transition/private/Animator';
/**
 * @class Sequence
 * @since 1.0.0
 * @hidden
 */
export class SequenceAnimator extends Animator {
    constructor() {
        super(...arguments);
        /**
         * @property state
         * @since 1.0.0
         */
        this.state = SequenceAnimatorState.Starting;
    }
    /**
     * @inherited
     * @function insert
     * @since 1.0.0
     */
    insert(key, component, from) {
        this.presentAnimationState[key] = AnimationState.Awaits;
        this.present[key] = component;
        const processing = key in from.content;
        const presenting = key in from.present;
        const dismissing = key in from.dismiss;
        if (processing == false) {
            return;
        }
        if (presenting) {
            const state = from.presentAnimationState[key];
            if (state == AnimationState.Awaits || state == AnimationState.Active) {
                this.presentAnimationState[key] = state;
            }
        }
        if (dismissing) {
            const state = from.dismissAnimationState[key];
            if (state == AnimationState.Awaits || state == AnimationState.Active) {
                this.presentAnimationState[key] = state;
            }
        }
    }
    /**
     * @inherited
     * @function remove
     * @since 1.0.0
     */
    remove(key, component, from) {
        this.dismissAnimationState[key] = AnimationState.Awaits;
        this.dismiss[key] = component;
        const processing = key in from.content;
        const presenting = key in from.present;
        const dismissing = key in from.dismiss;
        if (processing == false) {
            return;
        }
        if (presenting) {
            const state = from.presentAnimationState[key];
            if (state == AnimationState.Awaits || state == AnimationState.Active) {
                this.dismissAnimationState[key] = state;
            }
        }
        if (dismissing) {
            const state = from.dismissAnimationState[key];
            if (state == AnimationState.Awaits || state == AnimationState.Active) {
                this.dismissAnimationState[key] = state;
            }
        }
    }
    /**
     * @inherited
     * @function update
     * @since 1.0.0
     */
    update(key, component, from) {
        this.content[key] = component;
    }
    /**
     * @method start
     * @returns
     */
    play() {
        return __awaiter(this, void 0, void 0, function* () {
            this.state = SequenceAnimatorState.Dismissing;
            if (this.dismissCount) {
                yield this.prepareDismissItems();
                if (this.aborted)
                    return;
                yield this.dismissItems();
                if (this.aborted)
                    return;
            }
            this.state = SequenceAnimatorState.Presenting;
            if (this.presentCount) {
                yield this.preparePresentItems();
                if (this.aborted)
                    return;
                yield this.presentItems();
                if (this.aborted)
                    return;
            }
            this.state = SequenceAnimatorState.Finished;
        });
    }
}
/**
 * @function toAnimationStateName
 * @since 1.0.0
 * @hidden
 */
function toAnimationStateName(state) {
    switch (state) {
        case AnimationState.None:
            return 'None';
        case AnimationState.Active:
            return 'Active';
        case AnimationState.Awaits:
            return 'Awaits';
    }
}
export var SequenceAnimatorState;
(function (SequenceAnimatorState) {
    SequenceAnimatorState[SequenceAnimatorState["Starting"] = 0] = "Starting";
    SequenceAnimatorState[SequenceAnimatorState["Presenting"] = 1] = "Presenting";
    SequenceAnimatorState[SequenceAnimatorState["Dismissing"] = 2] = "Dismissing";
    SequenceAnimatorState[SequenceAnimatorState["Finished"] = 3] = "Finished";
})(SequenceAnimatorState || (SequenceAnimatorState = {}));
function toSequenceAnimatorStateName(state) {
    switch (state) {
        case SequenceAnimatorState.Starting:
            return 'Starting';
        case SequenceAnimatorState.Presenting:
            return 'Presenting';
        case SequenceAnimatorState.Dismissing:
            return 'Dismissing';
        case SequenceAnimatorState.Finished:
            return 'Finished';
    }
}
